(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-header-mega-menu"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-toggle-menu]').forEach((toggleBtn) => {
const megaMenu = toggleBtn.nextElementSibling;
if (!megaMenu) return;

toggleBtn.addEventListener('click', (e) => {
e.preventDefault();

const isOpen = megaMenu.hidden === false;

// すべてのメガメニューを閉じる（他を開いている場合）
document.querySelectorAll('.mega-menu').forEach(menu => menu.hidden = true);
document.querySelectorAll('[data-toggle-menu]').forEach(btn => btn.classList.remove('is-active'));

if (!isOpen) {
megaMenu.hidden = false;
toggleBtn.classList.add('is-active');
} else {
// 閉じた場合の初期化
document.querySelectorAll('.level-1-item > a, .level-2-item > a').forEach(a => a.classList.remove('is-active'));
document.querySelectorAll('.level-2, .level-3').forEach(el => el.hidden = true);
}
});
});

// level-1 のリンクに対する処理
document.querySelectorAll('.level-1-item > a').forEach(link => {
link.addEventListener('click', (e) => {
if (link.classList.contains('has-children')) {
e.preventDefault();

const category = link.parentElement.dataset.category;

// level-2 表示制御
document.querySelectorAll('.level-2').forEach(el => {
el.hidden = el.dataset.parent !== category;
});

// level-3 はすべて閉じる
document.querySelectorAll('.level-3').forEach(el => el.hidden = true);

// active付け替え
document.querySelectorAll('.level-1-item > a').forEach(a => a.classList.remove('is-active'));
document.querySelectorAll('.level-2-item > a').forEach(a => a.classList.remove('is-active'));
link.classList.add('is-active');
}
// else は何もしない → 通常遷移
});
});

// level-2 のリンクに対する処理
document.querySelectorAll('.level-2-item > a').forEach(link => {
link.addEventListener('click', (e) => {
if (link.classList.contains('has-children')) {
e.preventDefault();

const sub = link.parentElement.dataset.sub;

// level-3 表示制御
document.querySelectorAll('.level-3').forEach(el => {
el.hidden = el.dataset.subParent !== sub;
});

// active付け替え
document.querySelectorAll('.level-2-item > a').forEach(a => a.classList.remove('is-active'));
link.classList.add('is-active');
}
// else → 通常遷移
});
});



document.addEventListener('click', (e) => {
const header = document.querySelector('.l-header__nav');

// クリック対象がヘッダー内に含まれている場合はスキップ
if (header && header.contains(e.target)) return;

// メガメニューとアクティブクラスを閉じる
document.querySelectorAll('.mega-menu').forEach(menu => menu.hidden = true);
document.querySelectorAll('[data-toggle-menu]').forEach(btn => btn.classList.remove('is-active'));
document.querySelectorAll('.level-1-item > a, .level-2-item > a').forEach(a => a.classList.remove('is-active'));
document.querySelectorAll('.level-2, .level-3').forEach(el => el.hidden = true);
});
  } catch(e) { console.error(e); }
})();

})();
